// Internal Imports
import { AUTH } from "../../constants";
import { GlobalUtils } from "../../utils";

// Destructuring
const { DOMAIN_NAME, WEBSITE_DOMAIN_URL, LOCAL, AUTH_URL } = AUTH;
const { readDataFromLocalStorage, readCookie } = GlobalUtils;

// check if User is authenticated or not
export const isUserAuthenticated = () => {
  const user = readDataFromLocalStorage("revvsalesUser");
  const accessToken = readCookie("accessToken");
  const refreshToken = readCookie("refreshToken");
  if (user && user.org_id && (accessToken || refreshToken)) {
    return true;
  }
  return false;
};

// get user's valid domain url
export const getValidDomainUrl = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  return WEBSITE_DOMAIN_URL[envName];
};

// get user's valid subdomain url
export const getValidSubDomainUrl = subdomain => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  if (envName === LOCAL) {
    return `http://${DOMAIN_NAME[envName]}`;
  }
  return `https://${subdomain}.${DOMAIN_NAME[envName]}`;
};

// get user's valid subdomain full url
export const getValidFullSubDomainUrl = subdomain => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  const { pathname, search } = window.location;
  if (envName === LOCAL) {
    return `http://${DOMAIN_NAME[envName]}${pathname}${search}`;
  }
  return `https://${subdomain}.${DOMAIN_NAME[envName]}${pathname}${search}`;
};

export const getRedirectUrlPostSignout = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  return AUTH_URL[envName];
};
